import { setLoanPortal } from 'actions/dashboardPortal';
import { BankAccountsStatus } from 'enums/BankAccountsStatus';

import { ApplicationDto } from '../api/ApplicationApi';

export const updateRequiredInformation = (borrowerApplication: ApplicationDto, dispatch: any) => {
  const variables = borrowerApplication?.variables;

  const borrowerEmploymentInformationComplete = variables.borrower_employment_information_complete as boolean;
  const coBorrowerEmploymentInformationComplete = variables.coborrower_employment_information_complete as boolean;
  const fundingInformationComplete = variables.funding_information_complete as boolean;
  const borrowerPayrollProviderIsDisabled = variables.borrower_payroll_provider_is_disabled as boolean;
  const coBorrowerPayrollProviderIsDisabled = variables.coborrower_payroll_provider_is_disabled as boolean;
  const borrowerInformationRequired = variables.borrower_information_required as boolean;
  const coBorrowerInformationRequired = variables.coborrower_information_required as boolean;
  const fundingInformationIsRequired = variables.funding_information_is_required as boolean;
  const isThereNonBorrowingCoOwner = variables.is_there_a_non_borrowing_coowner as boolean;
  const homeOwnershipInformationComplete = variables.homeownership_information_complete as boolean;
  const bankAccountsStatus = variables.bank_accounts_refresh_status as BankAccountsStatus;
  const fundingInformationErrorMessage = variables.giact_validation_error_message;
  const financialAccountAggregationAttemptComplete =
    variables.borrower_financial_account_aggregation_attempt_complete as boolean;
  const autopayDefaultValue = typeof variables.autopay === 'boolean' ? variables.autopay : null;
  const autopaySectionIsRequired = variables.autopay_required as boolean;
  const autopaySectionIsCompleted = autopayDefaultValue !== null;

  dispatch(
    setLoanPortal({
      borrowerPayrollProviderIsDisabled: borrowerPayrollProviderIsDisabled,
      coBorrowerPayrollProviderIsDisabled: coBorrowerPayrollProviderIsDisabled,
      borrowerInformationRequired: borrowerInformationRequired,
      coBorrowerInformationRequired: coBorrowerInformationRequired,
      fundingInformationIsRequired: fundingInformationIsRequired,
      fundingInformationComplete: fundingInformationComplete,
      payrollProviderBorrowerVerificationStates: variables.payroll_provider_borrower_verification_states,
      payrollProviderCoBorrowerVerificationStates: variables.payroll_provider_coborrower_verification_states,
      isThereNonBorrowingCoOwner: isThereNonBorrowingCoOwner,
      homeOwnershipInformationComplete: homeOwnershipInformationComplete,
      borrowerEmploymentInformationComplete: borrowerEmploymentInformationComplete,
      coBorrowerEmploymentInformationComplete: coBorrowerEmploymentInformationComplete,
      bankAccountsStatus: bankAccountsStatus,
      fundingInformationErrorMessage: fundingInformationErrorMessage,
      financialAccountAggregationAttemptComplete: financialAccountAggregationAttemptComplete,
      autopayDefaultValue: autopayDefaultValue,
      autopaySectionIsRequired: autopaySectionIsRequired,
      autopaySectionIsCompleted: autopaySectionIsCompleted,
    }),
  );
};
